var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h2',{staticClass:"m-2 text-center"},[_vm._v("Admin")]),_c('b-button',{on:{"click":_vm.getUsers}},[_vm._v("Get Users")]),_c('p',[_vm._v(_vm._s(_vm.users.data))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }